module.exports = __webpack_public_path__ + "static/media/assessment-end-screen-footer.09604c64.png";